import PageData from '@v4/utils/data/PageData'
import SignUpButton from '../SignUpButton'
import LinkButton from '../LinkButton'
import ChangeEmailButton from '../ChangeEmailButton'

export const ACTIONS = {
	DEFAULT: 'default',
	CHANGE_EMAIL: 'change-email',
	LINK: 'link',
	OPEN_LEAD_FORM: 'open-lead-form',
}

export const ELEMENTS = {
	[PageData.TYPES.LANDING]: {
		[ACTIONS.DEFAULT]: SignUpButton,
		[ACTIONS.OPEN_LEAD_FORM]: SignUpButton,
		[ACTIONS.LINK]: LinkButton,
	},
	[PageData.TYPES.RESULT]: {
		[ACTIONS.CHANGE_EMAIL]: ChangeEmailButton,
		[ACTIONS.DEFAULT]: LinkButton,
		[ACTIONS.LINK]: LinkButton,
	},
	[PageData.TYPES.QUESTION]: {},
	[PageData.TYPES.RESULT_PDF]: {},
}
